import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withModifiers as _withModifiers, renderSlot as _renderSlot, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/mobile-code.png'
import _imports_1 from '@/assets/mobile-qrcode.png'


const _withScopeId = n => (_pushScopeId("data-v-790fd2da"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { style: {"color":"white"} }, "选择租户：", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { style: {"color":"white"} }, "选择项目：", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  style: {"vertical-align":"text-top"}
}, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "",
  class: "qrode-code"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_tree_select = _resolveComponent("a-tree-select")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!
  const _component_bell_outlined = _resolveComponent("bell-outlined")!
  const _component_a_badge = _resolveComponent("a-badge")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_space, null, {
      default: _withCtx(() => [
        (_ctx.tenantList.length > 1)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _hoisted_1,
              _createVNode(_component_a_select, {
                value: _ctx.tenantId,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tenantId) = $event)),
                placeholder: "请选择账号所属租户",
                style: {"width":"300px","text-align":"left"},
                options: _ctx.tenantList,
                fieldNames: { label: 'name', value: 'id' },
                onChange: _ctx.changeTenant
              }, null, 8, ["value", "options", "onChange"])
            ], 64))
          : _createCommentVNode("", true),
        _hoisted_2,
        _createVNode(_component_a_tree_select, {
          value: _ctx.projectId,
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.projectId) = $event)),
          "tree-data": _ctx.projectTreeList,
          placeholder: '请选择项目',
          fieldNames: { value: 'id', label: 'projectName', children: 'children' },
          onChange: _ctx.handleProjectChange,
          style: {"width":"300px","text-align":"left"},
          "tree-default-expand-all": "",
          "allow-clear": "",
          "show-search": ""
        }, null, 8, ["value", "tree-data", "onChange"])
      ]),
      _: 1
    }),
    _createVNode(_component_a_dropdown, {
      visible: _ctx.mobileCodeVisible,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.mobileCodeVisible) = $event)),
      placement: "bottom"
    }, {
      overlay: _withCtx(() => [
        _hoisted_5
      ]),
      default: _withCtx(() => [
        _createElementVNode("a", {
          class: "ant-dropdown-link",
          onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"])),
          style: {"padding":"0 0 0 15px"}
        }, _hoisted_4)
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_a_dropdown, {
      class: "ant-pro-dropdown ant-pro-dropdown-action",
      placement: "bottomRight",
      trigger: ['click'],
      visible: _ctx.visible,
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.visible) = $event)),
      overlayClassName: "pro-components-header-notice-icon-index-container"
    }, {
      overlay: _withCtx(() => [
        _createElementVNode("div", null, [
          _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("span", {
          class: _normalizeClass(['noticeButton', { opened: _ctx.visible }])
        }, [
          _createVNode(_component_a_badge, {
            count: _ctx.count,
            style: { boxShadow: 'none' },
            class: "badge"
          }, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "bell", {}, () => [
                _createVNode(_component_bell_outlined, {
                  class: "icon",
                  style: {"color":"#ffffff"}
                })
              ], true)
            ]),
            _: 3
          }, 8, ["count"])
        ], 2)
      ]),
      _: 3
    }, 8, ["visible"])
  ], 64))
}